import { useEffect, useState, createRef, useRef } from "react";
import ReactDOM from "react-dom";
import TagPop from "./components/tagPop";
import { Overlay } from "react-bootstrap";
import "./index.scss";
import DzTips from "@/components/dzTips";
function MarkDiv({ className, children }) {
  const [markHtml, setMarkHtml] = useState("");
  useEffect(() => {
    if (children) {
      setMarkHtml(children);
    }
    const preventClearSelection = (event) =>{
        setTimeout(()=>{
            console.log('selecttetttt:',window.getSelection().toString())
            setSelectedText(window.getSelection().toString())
        },500)
    }
    document.addEventListener('mousedown',preventClearSelection)
    return ()=>{
        document.removeEventListener('mousedown',preventClearSelection)
    }
  },[]);

  const [selectedText, setSelectedText] = useState("");
  useEffect(() => {
    if (selectedText) {
      showTips();
    } else {
      closeTips();
    }
  }, [selectedText]);
  const mouseUphandle = (e) => {
    console.log("e");
    const selectedText = window.getSelection().toString();
    setSelectedText(selectedText);
    console.log("selectedText:", selectedText);
  };
  const [tipsVisible, setTipsVisible] = useState(false);
  const target = useRef(null);
  const showTips = () => {
    setTipsVisible(true);
  };
  const closeTips = () => {
    setTipsVisible(false);
  };

  return (
    <div className="mark-box">
      <div
        ref={target}
        className={`mark-div ${className}`}
        onMouseUp={(e) => mouseUphandle(e)}
        dangerouslySetInnerHTML={{ __html: markHtml }}
      ></div>
      <DzTips visible={tipsVisible} container={target} text={selectedText}></DzTips>
    </div>
  );
}
export default MarkDiv;
